var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page l-header--fixed",attrs:{"id":"app"}},[_c('nav-header'),_c('keep-alive',[_c(_vm.currentPage,{tag:"component"})],1),_c('nav-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }